module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-298.7eee250.woff2";